import { TranslationMap } from 'shared/i18n/interface'
import { createContext } from 'react'

export interface IntlContextInterface {
  messages: TranslationMap
}

export const IntlContext = createContext<IntlContextInterface>({ messages: {} })
